import { TypingResult } from '../api';

// 級は番号が大きいほど易しく、進行は「番号が大きい級 → 小さい級」。
// 最も進んだクリア級 ＝ クリア済みのうち最も番号が小さい級。
const getClearedGrade = (typingResults: TypingResult[]): number | undefined => {
  const clearedGradeNumbers = typingResults
    .filter((typingResult) => typingResult.firstClearedAt)
    .map((typingResult) => typingResult.gradeNumber);
  if (clearedGradeNumbers.length === 0) {
    return undefined;
  }
  return Math.min(...clearedGradeNumbers);
};

export const isGradeUnlocked = (typingResults: TypingResult[], gradeNumber: number): boolean => {
  const exists = typingResults.some((typingResult) => typingResult.gradeNumber === gradeNumber);
  if (!exists) {
    return false;
  }
  const clearedGrade = getClearedGrade(typingResults);
  if (clearedGrade === undefined) {
    const easiestGrade = Math.max(...typingResults.map((typingResult) => typingResult.gradeNumber));
    return gradeNumber === easiestGrade;
  }
  return gradeNumber >= clearedGrade - 1;
};
